import { Back, Elastic, Sine, TimelineLite } from "gsap";
import * as Constants from "../Data/Constants";
import * as SFX from "../Data/SoundEffectKeys";
import * as VoiceOver from "../Data/VoiceOverKeys";
import { Button } from "../GameObjects/Button";

export class SplashPlayButton extends Button {
    private _timeline: TimelineLite | undefined;

    constructor(pCallback: () => void) {
        super(pCallback, "button-start", Constants.SPRITESHEET_UI, VoiceOver.PLAY, SFX.UI_SELECT);
        // Remove the bottom portion of the hitArea to account for baked-in shadow
        this.hitArea = new PIXI.Rectangle(
            -this._image!.width * 0.5,
            -this._image!.height * 0.5,
            this._image!.width,
            this._image!.height * 0.925,
        );
        this.visible = false;
        this.interactive = false;
        this._autoPulse = true;
    }

    public animateIn(): void {
        this.alpha = 0;
        this._visuals.scale.set(0.5);
        this.visible = true;

        this._timeline = new TimelineLite();
        this._timeline.to(this, 0.35, {
            alpha: 1,
            ease: Sine.easeOut,
        }, 0);
        this._timeline.to(this._visuals.scale, 1.0, {
            x: 1,
            y: 1,
            ease: Elastic.easeOut,
        }, 0);
        this._timeline.call(this.playPulse.bind(this));
        this._timeline.call(() => this.interactive = true, undefined, this, 0.35);
    }

    public animateOut(): void {
        if (this._timeline !== undefined) { this._timeline.kill(); }
        this.interactive = false;

        this._timeline = new TimelineLite();
        this._timeline.to(this, 1.0, {
            y: 500,
            ease: Back.easeIn,
        });
    }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._timeline !== undefined) { this._timeline.kill(); }
        super.destroy(pOptions);
    }
}
